import React, { Fragment } from "react";
import Loader from "components/sales/Loader/loader";
import './formSection.css'
const FormSection = ({ children, title, status, isLoading = false, headerData }) => {
  return (
    <Fragment>
      <div className="card">
        <div className="card-header n-card">
        {title}  <span
            style={{float : "right"}}
            className={`status-td ${
              status === "Approved"
                ? `warm`
                : status === "Pending"
                ? "cold"
                : status === "Created"
                ? "completed"
                : ""
            }`}
          >
            {headerData ? headerData : status}
          </span>
        </div>
        <div className="card-body">
        {children}
        </div>
      </div>
      {/* <div className="panel-inherit">
      <div className="panel-card">
       
        <div className={title ? "panel-heading" : ""}>
          {title}
          <span
            className={`status-td ${
              status === "Approved"
                ? `warm`
                : status === "Pending"
                ? "cold"
                : status === "Created"
                ? "completed"
                : ""
            }`}
          >
            {status}
          </span>
        </div>
        </div>
        <div className="panel-body panel-N panel-pr panel-col  mx-0">{children}</div>
      </div> */}
    
      <Loader isLoading={isLoading} />
    </Fragment>
  );
};

export default FormSection;
